<div class="mb-2">
  <mat-expansion-panel class="mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title class="loren-faq-section-question">
        <mat-icon class="loren-faq-section-icon">help_outline</mat-icon>
        {{ faqTitle | transloco }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div
      [innerHTML]="faqAnswer | transloco"
      class="loren-faq-section-answer"
    ></div>
  </mat-expansion-panel>
</div>
